import { LogActivityMutation } from 'API';
import { API } from 'aws-amplify';
import APIContext from 'context/APIContext';
import AuthContext from 'context/AuthContext';
import { logActivity } from 'graphql/mutations';
import { useContext } from 'react';

interface LoggingParams {
  action: string;
  ip?: string | null;
  url?: string | null;
}

type LoggingResult = (params: LoggingParams) => Promise<boolean>;

export const useLoggingActivity = (): LoggingResult => {
  const { getEnvironment } = useContext(APIContext);
  const { user } = useContext(AuthContext);

  const logActivityMutation = async (params: LoggingParams): Promise<boolean> => {
    console.log('Logging activity mutation');
    try {
      const variables = {
        Username: user?.username,
        Action: params.action,
        Environment: getEnvironment,
        Service: 'OMG PORTAL',
        Url: params.url || window.location.href,
        // Url: 'https://staging.d14m7mqqq19qxk.amplifyapp.com/reporting?client=TEL%23DK',
        ...(params.ip && { Ip: params.ip }),
      };

      (await API.graphql({
        query: logActivity,
        variables,
        authMode: 'AWS_IAM',
      })) as { data: LogActivityMutation };

      return true;
    } catch (e) {
      console.error('Error logging activity', e);
      return false;
    }
  };

  return logActivityMutation;
};
